export const FETCH_DOCUMENT_TYPE = "document_type/FETCH_DOCUMENT_TYPE";
export const FETCH_DOCUMENT_TYPE_SUCCESS = "document_type/FETCH_DOCUMENT_TYPE_SUCCESS";
export const FETCH_DOCUMENT_TYPE_FAILURE = "document_type/FETCH_DOCUMENT_TYPE_FAILURE";
export const RESET_DOCUMENT_TYPE = "document_type/RESET_DOCUMENT";



// WEBPACK FOOTER //
// ./src/store/document-type/actionTypes.js